import React, { useEffect, useState } from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import ContainerApAbierto from "./ContainerApAbierto";
import Formulario from "../Generales/Formulario";
import { urlPlanesApAbiertoDetalleCategoria, urlRecuperarCarritoAccP } from "../../constants/urls";
import TablaPlanes from "../Generales/TablaPlanes";
import { apiPost2 } from "../../api";
import Valores from "./Valores";
import { empresa } from "../../constants";


const ComponentApAbiertoCategoria = (props) => {

    const queryParams = new URLSearchParams(props.location.search);
    const idCarrito = queryParams.get("id");
    const categoria = queryParams.get("categoria");
    const [carritoActual, setCarritoActual] = useState(null)

    const [loading, setLoading] = useState(false)
    const [mostrarTabla, setMostrarTabla] = useState(false)
    const [values, setValues] = useState({})
    const [verBoton, setVerBoton] = useState(false)
    const [editaAsistencias, setEditaAsistencias] = useState(false)
    const [valuesCoberturas, setValuesCoberturas] = useState({})
    const [valuesAsistencia, setValuesAsistencia] = useState({})
    const [idProducto, setIdProducto] = useState(null)
    const [coberturas, setCoberturas] = useState([])
    const [totales, setTotales] = useState({})
    const [tieneErrores, setTieneErrores] = useState(null)
    const [coberturas2, setCoberturas2] = useState([])
    const [titulo, setTitulo] = useState('')
    const [codProducto, setCodProducto] = useState('')

    const [asistencias, setAsistencias] = useState([])
    const [asistenciasSeleccionadas, setAsistenciasSeleccionadas] = useState([])
    const [asistenciasExpandidas, setAsistenciasExpandidas] = useState([])
    const [numeroDias, setNumeroDias] = useState(0)

    const [validate, setValidate] = useState(false);
    const [tituloPrimaNeta, setTituloPrimaNeta] = useState(null);
    const [tituloPrimaTotal, setTituloPrimaTotal] = useState(null);
    const [mostrarAsistencias, setMostrarAsistencias] = useState(false)

    useEffect(() => {

        window.scrollTo(0, 0);


    }, [])

    useEffect(() => {

        const val = { ...values, numeroDias: numeroDias }
        console.log('resultado', val)

        setValues(val)



    }, [numeroDias])

    const idCarritoParam = queryParams.get("id");

    /**
   * recupera la información del carrito
   */
    const recuperarCarrito = async () => {

        setLoading(true)


        if (idCarritoParam) {
            const resultado = await apiPost2(urlRecuperarCarritoAccP, {
                empresa: empresa,
                idCarrito: idCarritoParam
            })

            if (resultado.transaccion) {
                setCarritoActual(resultado)


                if (resultado.carDescripcionSeguro == 'AP Segmentos Especiales') {
                    setTituloPrimaNeta('Prima Neta por período')
                    setTituloPrimaTotal('Prima Total por período')
                }

                if (resultado.carDescripcionSeguro == 'ACCIDENTES PERSONALES ABIERTO') {


                    setTituloPrimaNeta('Prima Neta ' + resultado.facturacion.label + ' por persona')
                    setTituloPrimaTotal('Prima Neta ' + resultado.facturacion.label)
                }



                setNumeroDias(resultado.facturacion.numeroDias)




            }


        }
        setLoading(false)


    }



    const obtenerInformacionActividad = async (valores) => {

        var url = `${urlPlanesApAbiertoDetalleCategoria}`;
        setLoading(true)
        var body = {
            "empresa": "AIGMETROPOLITANA",
            "plataforma": "WEB",
            "ambiente": "Desarrollo",
            "idCarrito": idCarrito,
            "codigoProductoActual": categoria
        }


        try {
            const resultado = await apiPost2(url, body)


            if (resultado.transaccion) {


                var objeto = valores
                objeto.categoria = resultado.datosProductos.actividad
                objeto.numeroPersonas = resultado.datosProductos.numeroPersonas
                objeto.muerteAccidental = resultado.datosProductos.valorMuerteAccidental
                objeto.fracturaHuesos = resultado.datosProductos.valorFracturaHuesos ? resultado.datosProductos.valorFracturaHuesos : 0
                objeto.numeroDias = resultado.datosProductos.numeroDias ? resultado.datosProductos.numeroDias : 0


                console.log('verTabla', objeto)

                setValues(objeto)
                setIdProducto(resultado.codigoProductoActual)
                setCoberturas(resultado.datosProductos.coberturas)

                if (objeto.numeroDias > 90) {
                   setMostrarAsistencias(true)
                } else {
                    setMostrarAsistencias(false)
                }

                setMostrarTabla(true)

                setVerBoton(true)

                setTotales(resultado.datosProductos)


            }

            setLoading(false)

        } catch (error) {
            setLoading(false)
        }
    }



    return (
        <ContainerApAbierto
            paso={'cotizacion'}
            titulo={props.datosCotizador.titulo}
        >

            <main class="cr-app bg-light">
                <div class="cr-content container-fluid">
                    <div className="container-body-spaces">

                        <LoadingScreen
                            loading={
                                loading
                            }

                            bgColor="#f1f1f1"
                            spinnerColor="#001871"
                            textColor="#676767"
                            logoSrc={logo}
                            text="Obteniendo datos..."
                        >

                            <Row>
                                <Col md={12} sm={12} lg={8} xl={8}>


                                    <Formulario
                                        codigoFormulario={props.datosCotizador.codigoFormulario}
                                        onSubmit={(valores, tieneErrores, errores) => {
                                            if (!tieneErrores) {
                                                if (valores.numeroDias > 90) {
                                                    setMostrarAsistencias(true)
                                                } else {
                                                    setMostrarAsistencias(false)
                                                }
                                                setMostrarTabla(true)
                                                setVerBoton(true)

                                            } else {
                                                setMostrarTabla(false)
                                                setMostrarAsistencias(false)
                                                setVerBoton(false)
                                            }
                                        }}
                                        values={values}
                                        setLoading={(value) => setLoading(value)}

                                        onChange={(key, values) => {


                                            setMostrarTabla(false)
                                            setVerBoton(false)
                                            setTotales({})

                                            setValues(values)

                                        }}

                                        setValuesInicial={(values) => {

                                            if (categoria) {
                                                obtenerInformacionActividad(values)
                                            } else {
                                                console.log('resultado2', values)
                                                setValues(values)
                                            }

                                            recuperarCarrito()



                                        }}
                                    />
                                    {(mostrarTabla && carritoActual) &&

                                        <div>
                                            <TablaPlanes
                                                verBoton={verBoton}
                                                editaAsistencias={editaAsistencias}
                                                setEditaAsistencias={(valor) => { setEditaAsistencias(valor) }}
                                                agregarAsistencias={values.agregarAsistencias}
                                                setMostrarTabla={(value) => setMostrarTabla(value)}
                                                mostrarTabla={mostrarTabla}
                                                carritoActual={carritoActual}
                                                idProducto={idProducto}
                                                categorias={coberturas}
                                                categoria={values.categoria ? values.categoria.value : null}
                                                categoriaObjeto={values.categoria}
                                                muerteAccidental={values.muerteAccidental}
                                                valorFracturaHuesos={values.fracturaHuesos ? values.fracturaHuesos : 0}
                                                numeroDias={values.numeroDias ? values.numeroDias : 0}
                                                numeroPersonas={values.numeroPersonas}
                                                idCarrito={idCarrito}
                                                actividad={categoria}
                                                history={props.history}
                                                totales={totales}
                                                setTotales={(valor) => { setTotales(valor) }}
                                                setTitulo={(valor) => { setTitulo(valor) }}
                                                setCodProducto={(valor) => { setCodProducto(valor) }}
                                                codProducto={codProducto}
                                                valuesCoberturas={valuesCoberturas}
                                                setValuesCoberturas={(valor) => { setValuesCoberturas(valor) }}
                                                valuesAsistencia={valuesAsistencia}
                                                setValuesAsistencia={(valor) => { setValuesAsistencia(valor) }}
                                                tieneErrores={tieneErrores}
                                                setTieneErrores={(valor) => { setTieneErrores(valor) }}
                                                coberturas2={coberturas2}
                                                setCoberturas2={(valor) => setCoberturas2(valor)}
                                                asistencias={asistencias}
                                                setAsistencias={(valor) => { setAsistencias(valor) }}
                                                asistenciasSeleccionadas={asistenciasSeleccionadas}
                                                setAsistenciasSeleccionadas={(valor) => { setAsistenciasSeleccionadas(valor) }}
                                                asistenciasExpandidas={asistenciasExpandidas}
                                                setAsistenciasExpandidas={(valor) => { setAsistenciasExpandidas(valor) }}
                                                validate={validate}
                                                setValidate={(valor) => { setValidate(valor) }}
                                                mostrarAsistencias={mostrarAsistencias}
                                            />

                                        </div>



                                    }
                                    <Card>
                                        <CardBody>
                                            <Button
                                                onClick={() => {
                                                    props.history.push({
                                                        pathname: props.datosCotizador.urlRegresar,
                                                        search: `?id=${idCarrito}`, //agregar parametros de la url,
                                                    });
                                                }}
                                                className="btn btn-purple btn btn-secondary"
                                                style={{ marginLeft: "5px" }}
                                            >
                                                <i class="fa fa-chevron-circle-left" aria-hidden="true" />
                                                &nbsp;REGRESAR
                                            </Button>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col md={12} sm={12} lg={4} xl={4}>


                                    <Valores
                                        verBoton={verBoton}
                                        carritoActual={carritoActual}
                                        descripcionSeguro={props.datosCotizador.descripcionSeguro}
                                        codProducto={codProducto}
                                        editaAsistencias={editaAsistencias}
                                        setEditaAsistencias={(valor) => { setEditaAsistencias(valor) }}
                                        agregarAsistencias={values.agregarAsistencias}
                                        setMostrarTabla={(value) => setMostrarTabla(value)}
                                        mostrarTabla={mostrarTabla}
                                        idProducto={idProducto}
                                        categorias={coberturas}
                                        categoria={values.categoria ? values.categoria.value : null}
                                        categoriaObjeto={values.categoria}
                                        muerteAccidental={values.muerteAccidental}
                                        numeroDias={values.numeroDias ? values.numeroDias : 0}
                                        valorFracturaHuesos={values.fracturaHuesos ? values.fracturaHuesos : 0}
                                        numeroPersonas={values.numeroPersonas}
                                        idCarrito={idCarrito}
                                        actividad={categoria}
                                        history={props.history}
                                        urlSiguiente={props.datosCotizador.urlSiguiente}
                                        totales={totales}
                                        setTotales={(valor) => { setTotales(valor) }}
                                        valuesCoberturas={valuesCoberturas}
                                        setValuesCoberturas={(valor) => { setValuesCoberturas(valor) }}
                                        valuesAsistencia={valuesAsistencia}
                                        setValuesAsistencia={(valor) => { setValuesAsistencia(valor) }}
                                        tieneErrores={tieneErrores}
                                        setTieneErrores={(valor) => { setTieneErrores(valor) }}
                                        coberturas2={coberturas2}
                                        setCoberturas2={(valor) => setCoberturas2(valor)}
                                        asistencias={asistencias}
                                        setAsistencias={(valor) => { setAsistencias(valor) }}
                                        asistenciasSeleccionadas={asistenciasSeleccionadas}
                                        setAsistenciasSeleccionadas={(valor) => { setAsistenciasSeleccionadas(valor) }}
                                        validate={validate}
                                        setValidate={(valor) => { setValidate(valor) }}
                                        loading={loading}
                                        setLoading={(valor) => { setLoading(valor) }}
                                        paso={'cotizacion'}
                                        titulo={titulo}
                                        tituloPrimaNeta={tituloPrimaNeta}
                                        tituloPrimaTotal={tituloPrimaTotal}
                                    />
                                </Col>
                            </Row>










                        </LoadingScreen>



                    </div>
                </div>
            </main>

        </ContainerApAbierto>

    );
};
export default ComponentApAbiertoCategoria;